module.exports = __webpack_public_path__ + "static/img/Ellipse 98.c1d9e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 98.png
// module id = kp9o
// module chunks = 1